import React from 'react'
import './style.css'
import renderHTML from 'react-render-html';

export default (props) => {
    console.log('header component', props)
    return(
        <div className='header_content'>
            <span className='texto_apresentacao'>
                {renderHTML(props.texto)}
            </span>
            <span className='WMA_realiza'
                style={{
                        'position': 'absolute',
                        'bottom': '115 px',
                        'left': '10 px'
                }}
            >
                
            </span>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/website/header/conteudo/component.js